const ConversationActions = Marty.createActionCreators({
  searchConversations(query) {
    return this.app.queries.ConversationQueries.searchConversations(query)
  },
})

export default ConversationActions



// WEBPACK FOOTER //
// ./src/scripts/actions/ConversationActions.js